import { SearchItem } from "../../store/search";
import { ReactComponent as BlackArrowRight } from "../../assets/icons/chevron_right_black.svg";

const SearchResult = ({
  result,
  onClick,
  id,
  isActive,
  onMouseEnter,
}: {
  result: SearchItem;
  onClick: () => void;
  id?: string;
  isActive?: boolean;
  onMouseEnter?: () => void;
}) => (
  <li
    id={id}
    role="option"
    aria-selected={isActive ?? false}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    className={`px-4 h-[38px] cursor-pointer text-black w-[100%] p-2.5 gap-2.5 rounded-[50px] bg-[#F9F9F9] list-none ${
      isActive
        ? "bg-gray-200 outline outline-2 outline-[var(--col-border-focus)]"
        : "hover:bg-gray-100"
    }`}
  >
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <BlackArrowRight height={12} width={12} style={{ marginRight: 10 }} />
      {result.string}
    </div>
  </li>
);

export default SearchResult;
